import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AppscriptsUserService } from '../../shared/services/appscripts-user.service';
import { NotificationService } from '../../shared/services/notification.service';
import { UsersService } from '../../shared/services/users.service';
import { ValidationService } from '../../shared/services/validation.service';

@Component({
  standalone: false,
  selector: 'app-appscripts-balance-form',
  templateUrl: './appscripts-balance-form.component.html',
})
export class AppscriptsBalanceFormComponent implements OnChanges, OnInit {
  @Input() userId;
  @Output() onAfterSave = new EventEmitter();

  loading = false;

  model = {
    REFERRAL: { value: 0, newValue: 0, label: 'Referral' },
    MT_SMS: { value: 0, newValue: 0, label: 'In. Sms' },
    MO_SMS: { value: 0, newValue: 0, label: 'Out. Sms' },
    CALL: { value: 0, newValue: 0, label: 'Call' },
    BONUS: { value: 0, newValue: 0, label: 'Bonus' },
  };

  private note = 'Added by admin';

  constructor(
    protected elementRef: ElementRef,
    protected notificationService: NotificationService,
    protected service: AppscriptsUserService,
    protected validationService: ValidationService,
    protected userService: UsersService
  ) {}

  ngOnInit() {
    this.userService.i().subscribe(user => {
      this.note = `Added by ${user.email}`;
    });
  }

  getBalanceSum(type = null) {
    const types = type === null ? ['REFERRAL', 'MT_SMS', 'MO_SMS', 'CALL', 'BONUS'] : [type];
    let sum = 0;
    types.forEach(t => {
      sum += this.model[t].value;
      const newValue = parseFloat(this.model[t].newValue);
      sum += newValue ? newValue : 0;
    });
    return sum === 0 ? 0 : sum;
  }

  onSubmit() {
    const models = [];
    for (const i in this.model) {
      const val = parseFloat(this.model[i].newValue);
      if (val !== 0) {
        models.push({ value: Math.trunc(val * 100), type: i, note: this.note });
      }
    }
    this.loading = true;
    this.service.addBalance(this.userId, models).subscribe({
      next: balances => {
        this.loading = false;
        this.reset();
        this.setData(balances);
        this.notificationService.success('Balance updated', 'Balance');
        this.onAfterSave.emit();
      },
      error: error => {
        this.loading = false;
        this.validationService.handleRequestError(error, 'Balance');
      },
    });
  }

  update() {
    this.reset();
    this.loading = true;
    this.service.getBalance(this.userId).subscribe({
      next: balances => {
        this.setData(balances);
        this.loading = false;
      },
      error: e => {
        this.notificationService.error('Error request', 'Balance');
        this.loading = false;
      },
    });
  }

  private reset() {
    for (const i in this.model) {
      this.model[i].value = 0;
      this.model[i].newValue = 0;
    }
  }

  private setData(balances) {
    for (const type in balances) {
      if (!this.model[type]) {
        continue;
      }
      this.model[type].value = balances[type] / 100;
    }
  }

  ngOnChanges(changes) {
    if (changes.userId && changes.userId.currentValue) {
      this.update();
    }
  }
}
